import React, { useState } from "react";
import Form from "../../../node_modules/react-bootstrap/Form";
import Button from "react-bootstrap/esm/Button";
import Spinner from "react-bootstrap/Spinner";
import { Link } from "react-router-dom";
import * as Yup from "yup";

import { MODULES } from "../../utils/routesNames";
import { history } from "../../utils/appConfig";
import { SignUpDetails } from "../../modals/SignUp";
import { SignUpService } from "../../services/services";
import { Formik, Form as FormikForm } from "formik";
import { regEx, generalMessages } from "../../utils/constants";
import { toast } from "react-toastify";
import { LOGIN_LOGO } from "../../assets/images/images";

const signUpSchema = Yup.object({
  FirstName: Yup.string().required("First name is required"),
  MobileNumber: Yup.string()
    .matches(regEx.mobileNumberValidation, "Enter a valid mobile number")
    .required("Mobile number is required"),
  EmailID: Yup.string()
    .email("Enter a valid email address")
    .required("Email is required"),
  TradingName: Yup.string().required("Trading name is required"),
});

const SignUp: React.FC = () => {
  const [signUpState] = useState<SignUpDetails>({
    EmailID: "",
    FirstName: "",
    MobileNumber: "",
    TradingName: "",
  });

  const signInUser = async (credentials: SignUpDetails) => {
    const result = await SignUpService(credentials);
    if (result.data.flag) {
      toast.info(generalMessages.REGISTER_SUCCESS, { autoClose: false });
      history.push(MODULES.home.url);
    } else {
      toast.error(result.data.message);
    }
  };

  return (
    <div>
      {/* Register Wrapper Start */}
      <div className="form-wrapper-outer">
        <div className="form-wrapper">
          <div className="form-outer">
            {/* Register Form Start */}
            <div className="form-block">
              {/* Register Header Start */}
              <div className="form-header">
                <Link
                  to={MODULES.home.url}
                  title="ARZ Food Service"
                  className="logo"
                >
                  <img src={LOGIN_LOGO} alt="logo" />
                </Link>
              </div>
              {/* Register Header End */}

              {/* Register Body Start */}
              <div className="form-body">
                <h2>Register Account</h2>
                <Formik
                  enableReinitialize
                  validateOnChange
                  validateOnBlur
                  validationSchema={signUpSchema}
                  initialValues={signUpState}
                  onSubmit={(values) => signInUser(values)}
                >
                  {({
                    handleSubmit,
                    handleChange,
                    values,
                    touched,
                    errors,
                    handleBlur,
                    isSubmitting,
                  }) => (
                    <FormikForm onSubmit={handleSubmit}>
                      <Form.Group className="form-group">
                        <Form.Label>First Name</Form.Label>
                        <Form.Control
                          type="text"
                          className="form-control"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          name="FirstName"
                          value={values.FirstName}
                          isInvalid={touched.FirstName && !!errors.FirstName}
                        />
                        {/* <ErrorMessage name="FirstName" /> */}
                        <Form.Control.Feedback type="invalid">
                          {errors.FirstName}
                        </Form.Control.Feedback>
                      </Form.Group>
                      <Form.Group className="form-group">
                        <Form.Label>Mobile Number</Form.Label>
                        <Form.Control
                          type="text"
                          className="form-control"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          name="MobileNumber"
                          value={values.MobileNumber}
                          isInvalid={
                            touched.MobileNumber && !!errors.MobileNumber
                          }
                        />
                        {/* <ErrorMessage name="MobileNumber" /> */}
                        <Form.Control.Feedback type="invalid">
                          {errors.MobileNumber}
                        </Form.Control.Feedback>
                      </Form.Group>
                      <Form.Group className="form-group">
                        <Form.Label>Email</Form.Label>
                        <Form.Control
                          type="text"
                          className="form-control"
                          onChange={handleChange}
                          name="EmailID"
                          onBlur={handleBlur}
                          value={values.EmailID}
                          isInvalid={touched.EmailID && !!errors.EmailID}
                        />
                        {/* <ErrorMessage name="EmailID" /> */}
                        <Form.Control.Feedback type="invalid">
                          {errors.EmailID}
                        </Form.Control.Feedback>
                      </Form.Group>
                      <Form.Group className="form-group">
                        <Form.Label>Trading Name</Form.Label>
                        <Form.Control
                          type="text"
                          className="form-control"
                          onChange={handleChange}
                          name="TradingName"
                          onBlur={handleBlur}
                          value={values.TradingName}
                          isInvalid={
                            touched.TradingName && !!errors.TradingName
                          }
                        />
                        {/* <ErrorMessage name="TradingName" /> */}
                        <Form.Control.Feedback type="invalid">
                          {errors.TradingName}
                        </Form.Control.Feedback>
                      </Form.Group>
                      <Button
                        type="submit"
                        variant="primary"
                        disabled={isSubmitting}
                      >
                        {isSubmitting ? (
                          <Spinner animation="border" variant="light" />
                        ) : (
                          "Register"
                        )}
                      </Button>
                      <p className="register">
                        Already have an account ?{" "}
                        <Link
                          to={MODULES.login.url}
                          className="primary-link"
                          title="Login"
                        >
                          Login
                        </Link>
                      </p>
                    </FormikForm>
                  )}
                </Formik>
              </div>
              {/* Register Body End */}

              <p className="form-footer">
                <Link
                  to={MODULES.home.url}
                  className="white-link"
                  title="Back to Homepage"
                >
                  Back to Homepage
                </Link>
              </p>
            </div>
            {/* Register Form End */}
          </div>
        </div>
      </div>
      {/* Register Wrapper End */}
    </div>
  );
};

export default SignUp;
